import { IOffer } from "@/types/offer";
import {
  IPost,
  IPostCreateRequest,
  IPostRequest,
  IPostUpdateRequest,
} from "@/types/post";
import { IProposal } from "@/types/proposal";
import { IUser } from "@/types/user";
import { Offer } from "./offer";
import { Proposal } from "./proposal";
import { User } from "./user";

export class Post implements IPost {
  public id = 0;
  public company_id = 0;
  public user_id = 0;
  public contents = "";
  public system_message = "";
  public postable_type: "App\\Models\\Proposal" | "App\\Models\\Offer" =
    "App\\Models\\Proposal";
  public postable_id = 0;
  public created_at = "";
  public updated_at = "";

  public user: IUser = new User();
  public postable: IProposal | IOffer = new Proposal();

  public constructor(props?: IPost) {
    if (!props) {
      return;
    }
    Object.assign(this, props);
    if (props.user) {
      this.user = new User(props.user);
    }

    if (this.postable_type === "App\\Models\\Offer") {
      this.postable = new Offer(this.postable as IOffer);
    } else {
      this.postable = new Proposal(this.postable as IProposal);
    }
  }
  // public static toSelectItem(post: IPost): ISelectItem {
  //   return {
  //     text: post.name,
  //     value: post.id,
  //   };
  // }
}

export class PostRequest implements IPostRequest {
  public id = 0;
  // public postable_id = 0;
  public contents = "";
  public status_id = 0;
  [key: string]: unknown;

  public constructor(props?: IPost) {
    if (!props) {
      return;
    }
    Object.assign(this, props);
  }
}

export class PostCreateRequest
  extends PostRequest
  implements IPostCreateRequest {}

export class PostUpdateRequest
  extends PostRequest
  implements IPostUpdateRequest {}
